import React from 'react'
import { formatOptionValue } from '../../utils/formatters'

interface OptionItem {
  name: string
  value: number
}

interface OptionLeadersListProps {
  options: OptionItem[]
  /** Optional class name for the container */
  className?: string
}

/**
 * Renders a list of options with dot leaders between name and price.
 * Uses CSS overflow:hidden to clip excess dots - works great for live view.
 * For PDF export, the pdf-export.service calculates exact dot counts during cloning.
 *
 * Renders:
 * [Name] ......... [Formatted Price]
 */
export const OptionLeadersList: React.FC<OptionLeadersListProps> = ({
  options,
  className = ''
}) => {
  if (!options || options.length === 0) {
    return <span>-</span>
  }

  // Render enough dots to fill any reasonable column width
  // CSS overflow:hidden will clip the excess
  const dots = '.'.repeat(150)

  return (
    <div className={`ij-options-list ${className}`}>
      {options.map((option, idx) => (
        <div key={idx} className="ij-option-line">
          <span className="ij-option-name">{option.name}</span>
          <span className="ij-option-dots" aria-hidden="true">{dots}</span>
          <span className="ij-option-price">{formatOptionValue(option.value)}</span>
        </div>
      ))}
    </div>
  )
}

export default OptionLeadersList

